import React from "react";
import EasasGlobalAlerts from "./EasasGlobalAlerts";
import EasasGlobalChartDialog from "./EasasGlobalChartDialog";
import EasasGlobalConfirmDialog from "./EasasGlobalConfirmDialog";
import EasasGlobalTooltip from "./EasasGlobalTooltip";

export default function EasasGlobalFragment() {
  return (
    <>
      <EasasGlobalTooltip />
      <EasasGlobalAlerts />
      <EasasGlobalChartDialog />
      <EasasGlobalConfirmDialog />
    </>
  );
}
